import { useNavigate } from "react-router-dom";
import type { CountryLite } from "@shared/types";
import { api } from "../lib/api";
import { useAsync } from "../lib/useAsync";
import { Modal } from "./Modal";
import { CountryPickList } from "./CountryPickList";
import { useT } from "../i18n";

// App-wide search, opened from the nav 🔍. Searches countries today; the section
// layout leaves room for Candidates / Polls once those exist. Unlike the nation
// switcher, picking here just navigates — it does not change your home nation.
export function GlobalSearch({ onClose }: { onClose: () => void }) {
  const t = useT();
  const nav = useNavigate();
  const { data, loading, error } = useAsync(() => api.countries(), []);

  const pick = (c: CountryLite) => {
    onClose();
    nav(`/c/${c.id}`);
  };

  return (
    <Modal title={t("search.title")} onClose={onClose}>
      <h3 className="text-[11px] uppercase tracking-wide text-muted mb-2">🌍 {t("search.countries")}</h3>
      <CountryPickList countries={data} loading={loading} error={error} onPick={pick} />
      {/* Candidates and Polls search sections land in later steps. */}
    </Modal>
  );
}
